import { useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import SignIn from "../components/sign-in";
import SignUp from "../components/sign-up";
import { Eyebrow, SurfaceCard } from "../components/ui";

export default function SignInUp() {
  const [tab, setTab] = useState(0);

  return (
    <Box
      sx={{
        width: `min(100%, 480px)`,
        mx: "auto",
        px: { mobile: 2.5, tablet: 3 },
        py: { mobile: 5, laptop: 8 },
      }}
    >
      <Eyebrow>Installer portal</Eyebrow>
      <Typography variant="h2" sx={{ mb: 1 }}>
        {tab === 0 ? "Sign in." : "Create an account."}
      </Typography>
      <Typography variant="body1" sx={{ mb: 3 }}>
        Register Artome products and reach the installation guides.
      </Typography>

      <SurfaceCard>
        <Box sx={{ borderBottom: 1, borderColor: "divider", mb: 3 }}>
          <Tabs
            value={tab}
            onChange={(_, next: number) => setTab(next)}
            aria-label="Sign in or sign up"
            variant="fullWidth"
          >
            <Tab label="Sign in" id="auth-tab-0" aria-controls="auth-panel-0" />
            <Tab label="Sign up" id="auth-tab-1" aria-controls="auth-panel-1" />
          </Tabs>
        </Box>

        <Box
          role="tabpanel"
          id={`auth-panel-${tab}`}
          aria-labelledby={`auth-tab-${tab}`}
        >
          {tab === 0 ? <SignIn /> : <SignUp />}
        </Box>
      </SurfaceCard>
    </Box>
  );
}
